import ReactHtmlParser from 'react-html-parser';
import { Facility, HotelType, RoomType } from '../../../../types/HotelType';
import { ListHotelImageCarousel } from '../ListHotelImageCarousel/ListHotelImageCarousel';
import styles from './HotelRoomModalTabs.module.scss';

type HotelRoomModalProps = {
	room: RoomType,
	hotel: HotelType
}

export function HotelRoomModalTabs({ room, hotel }: HotelRoomModalProps) {

	let slidesPerView = 3;
	const mql = window.matchMedia('(max-width: 768px)');
	if (mql.matches) {
		slidesPerView = 1;
	}

	return (

		<div className={styles.modal}>
			<ListHotelImageCarousel photos={room.photos} slidesPerView={slidesPerView}/>
			<div className={styles.header}>
				<h2>{hotel.title}</h2>
				<span className={styles.tag}>{hotel.category}</span>
			</div>
			<h1>{room.title}</h1>
			<p>{`${hotel.address_street1}, ${hotel.address_city}, ${hotel.address_region}, ${hotel.address_postal_code}, ${hotel.address_country}`}</p>
			<p className={styles.descriptionText}>{room.desc_short}</p>
			<h2>Property Details</h2>
			<ul>
				{room.facilities.filter((facility: Facility) => facility.status === 1).map((facility: Facility, i: number) => {
					return <li key={i}>{facility.name}</li>;
				})}
			</ul>
		</div>
	)
}

